import axios from "axios";
import Cookies from "js-cookie"; 


const customAxios = axios.create({
  baseURL: window.env.REACT_APP_API_URL || "https://lab.kapitalai.io",
  withCredentials: true, 
});



customAxios.interceptors.request.use(
  (config) => {
    const token = Cookies.get("accessToken"); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default customAxios;
